module.exports = __webpack_public_path__ + "static/media/avgjore.1064a8e2.m4a";